import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  supplierName: {
    fontFamily: "Inter",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#232325",
    "& span": {
      fontWeight: 600,
    },
  },
  supplierEmail: {
    fontFamily: "Inter",
    fontStyle: "italic",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: "#12B76A",
    "& span": {
      fontWeight: 500,
    },
  },
}));

export default styles;
